import { createContext } from "react";
const ThemeManagerIDContext = createContext(1);
export { ThemeManagerIDContext };